import React, { useRef, useState } from "react";
import "../all css/newsupdate.css";
import Slider from "react-slick";
import { MdWest, MdEast } from "react-icons/md";
import { useNavigate } from "react-router-dom";

// import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";

const trending_img = require("../../assets/trending.png");
const news_img = require("../../assets/heading_news.png");

const news_vdo1 = require("../../assets/newsUpdate/newupdatevdohome.mp4");
const news_img1 = require("../../assets/newsUpdate/news1.png");
const news_img2 = require("../../assets/newsUpdate/news2.png");
const news_img3 = require("../../assets/newsUpdate/news5.png");
const news_img4 = require("../../assets/newsUpdate/news5.png");
const article_img1 = require("../../assets/blogs/blog1.jpg");
const article_img2 = require("../../assets/blogs/blog2.jpg");
const article_img3 = require("../../assets/blogs/blog3.jpg");
const article_img4 = require("../../assets/blogs/blog4.gif");
const article_img5 = require("../../assets/blogs/blog5.jpg");
const article_img6 = require("../../assets/blogs/blog6.jpg");
const article_img7 = require("../../assets/blogs/blog7.jpg");

const allFirstContent = [
  {
    newsCoverImg: news_img1,
    newsTitle:
      "Gurnoor Singh, Master of Engineering - Civil Engineering, University of Windsor",
    dateNews: "",
    shortDescription:
      "You aimed for big in life - studying, living, and working abroad. We at DWEC cherish standing up to those challenges. We congratulate you on getting a student visa. We are confident that your dedication, energy, and knowledge are extremely motivating and wish you many years of awesome achievement. ",

    longDescriptionNews: `<p>You aimed for big in life - studying, living, and working abroad. We at DWEC cherish standing up to those challenges. We congratulate you on getting a student visa. We are confident that your dedication, energy, and knowledge are extremely motivating and wish you many years of awesome achievement.&nbsp;</p>`,
  },
  {
    newsCoverImg: news_img2,
    dateNews: "",
    newsTitle: "Ayyan Surve, M.Sc in Management, University of Dundee",
    shortDescription:
      "Strength, dedication, difficulties, and confidence make your success worth remembering! A huge well did on this awesome opportunity that you got a student visa. DWEC team congratulates you for heading to do some incredible things and making us proud.Strength, dedication, difficulties, and confidence make your success worth remembering! A huge well did on this awesome opportunity that you got a student visa. DWEC team congratulates you for heading to do some incredible things and making us proud. ",
    longDescriptionNews: `<p>Strength, dedication, difficulties, and confidence make your success worth remembering! A huge well did on this awesome opportunity that you got a student visa. DWEC team&nbsp;congratulates you for heading to do some incredible things and making us proud.&nbsp;</p>`,
  },
];

const allSecItems = [
  {
    newsVideo: news_vdo1,
    newsCoverImg: news_img,
    dateNews: "",
    contentType: "video",
    newsTitle:
      "The Australian government announced a relaxation in working hours:",
    shortDescription: `
    Most Indian students pursuing their studies in Australia are concerned about the increasing costs attached to the pursuit of higher education, and working part-time while studying has become a necessity for these students. It gives first-hand experience in the marketplace that can help prepare you for the real working world besides a sense of security and responsibility like covering daily expenses, paying for tuition or miscellaneous academic fees, or just meeting their out-of-pocket expenses. This issue has become more and more apparent today.  
    
    The recently Australian government announcement came as a boon to many Indian holding Student Visas. The relaxation ensures that many of them can continue working for more than 40 hours per fortnight. 
    
    Welcoming the initiative for all our students currently on a student visa and in Adelaide. This will help them gain a meaningful experience in the working environment while supporting themselves financially during this difficult time,” says Nereshnee Shunmugam, CMU-A Director of Admissions & Student Affairs.  `,
    longDescriptionNews: `<div style="text-align: left;">
    <p style="font-weight: 400;">Most Indian students pursuing their studies in Australia are concerned about the increasing costs attached to the pursuit of higher education, and working part-time while studying has become a necessity for these students. It gives first-hand experience in the marketplace that can help prepare you for the real working world besides a sense of security and responsibility like covering daily expenses, paying for tuition or miscellaneous academic fees, or just meeting their out-of-pocket expenses. This issue has become more and more apparent today.&nbsp;&nbsp;</p>
    <p style="font-weight: 400;">&nbsp;</p>
    <p style="font-weight: 400;">The recently Australian government announcement came as a boon to many Indian holding Student Visas. The relaxation ensures that many of them can continue working for more than 40 hours per fortnight.&nbsp;<br /><br />Welcoming the initiative for all our students currently on a student visa and in Adelaide. This will help them gain a meaningful experience in the working environment while supporting themselves financially during this difficult time,&rdquo; says Nereshnee Shunmugam, CMU-A Director of Admissions &amp; Student Affairs.&nbsp;&nbsp;</p>
    <p style="font-weight: 400;">&nbsp;</p>
    <p style="font-weight: 400;">The announcement snippets:&nbsp;&nbsp;</p>
    <ul style="font-weight: 400;">
    <li>While pursuing their studies students can work more than 40 hours per fortnight.&nbsp;&nbsp;</li>
    <li>Students can seek employment before the start of their classes.&nbsp;&nbsp;</li>
    <li>Such students should meet the pre-requisite norms and maintain course enrollment, ensure satisfactory course attendance, and course progress, in compliance with their visa requirements.&nbsp;&nbsp;</li>
    <li>The relaxation of working hours also includes secondary applicants.&nbsp;&nbsp;</li>
    <li>The relaxation of working hours is time-bound and will not be extended beyond &nbsp;April 2022, subject to review by the government.&nbsp;&nbsp;</li>
    </ul>
    <p style="font-weight: 400;">Student visa holders who cancel their enrollment, stop attending classes, or fail to meet satisfactory progress, may result in a breach of their visa.&nbsp;<br /><br />This announcement gives a ray of hope to help new and returning students secure a job even before arriving in Adelaide.&nbsp;Australia offers hundreds of part-time and casual jobs across companies like retail, events, fast food, and hospitality. This opportunity will open doors for students to earn additional income, interact and meet new people, broaden their knowledge and create networking opportunities, and get a sneak peek into Australian culture.&nbsp;<br /><br />The relaxation comes with a caveat that students continuously maintain satisfactory academic performance while taking full advantage of this opportunity,&rdquo; adds Nereshnee.&nbsp;</p>
    </div>`,
  },
  {
    newsVideo: news_vdo1,
    newsCoverImg: news_img3,
    contentType: "image",
    shortDescription: `To meet the aspirations and bridge greater opportunities of Indians who are looking to live and work in the UK is hampered by stringent rules and higher fees.
    
    
    
     
    
    British Prime Minister Boris Johnson informed that the UK will walk the extra mile by offering more visas to India in order to clinch a free-trade deal aiming to boost annual bilateral trade by billions of pounds.
    
    
    
    The British PM signaled he has a pragmatic approach to the pending issue and looking to move forward by accommodating all issues that have stalled the talks.
    
    Britain is welcoming talented people to narrow the gap between the skills and economy. It is clear that a trade deal with India is a crucial post-Brexit priority free from the European Union's common trade policy is gearing up with policy favoring faster-growing economies in the Indo-Pacific region.
    
     
    
    Both India and former colonial power Britain share strong trade ties, and more than a million people of Indian origin live in Britain after decades of migration is a testimony.
    
    Britain wants to tap into the wealth of India's middle classes and their appetite for premium products and services. Extending its green technology to India Britain is looking to consolidate and strengthen the service trade.
    
    In the commercial aspect, the trade deal may double British exports to India, and by 2035 boost total trade by 28 billion pounds ($38 billion) per year. Total trade in 2019 was worth 23 billion pounds, according to British statistics.`,
    dateNews: "",
    newsTitle: "British PM Johnson signals visa flexibility to Indians",
    longDescriptionNews: `<p>To meet the aspirations and bridge greater opportunities of Indians who are looking to live and work in the UK is hampered by stringent rules and higher fees.</p>
    <p><br />&nbsp;</p>
    <p>British Prime Minister Boris Johnson informed that the UK will walk the extra mile by offering more visas to India in order to clinch a free-trade deal aiming to boost annual bilateral trade by billions of pounds.</p>
    <p><br />The British PM signaled he has a pragmatic approach to the pending issue and looking to move forward by accommodating all issues that have stalled the talks.<br /><br />Britain is welcoming talented people to narrow the gap between the skills and economy. It is clear that a trade deal with India is a crucial post-Brexit priority free from the European Union's common trade policy is gearing up with policy favoring faster-growing economies in the Indo-Pacific region.<br /><br />&nbsp;</p>
    <p>Both India and former colonial power Britain share strong trade ties, and more than a million people of Indian origin live in Britain after decades of migration is a testimony.<br /><br />Britain wants to tap into the wealth of India's middle classes and their appetite for premium products and services. Extending its green technology to India Britain is looking to consolidate and strengthen the service trade.<br /><br />In the commercial aspect, the trade deal may double British exports to India, and by 2035 boost total trade by 28 billion pounds ($38 billion) per year. Total trade in 2019 was worth 23 billion pounds, according to British statistics.</p>`,
  },
  {
    newsVideo: null,
    newsCoverImg: news_img4,
    contentType: "image",
    shortDescription: `
    There was an important announcement made by consular affairs at the US embassy in Delhi regarding different categories of non-immigrant visas.
    
    
    The embassy reiterated that applicants for F-1 student visas from India will have a high success rate of getting visa approval in the first interview whereas more possibilities of being refused in the second/third interview slots.
    
    This policy change will allow all the fresh applicants, who are turning up for the first time for a visa interview to study in a US college, a chance with an eye on blocking the earlier applicant who was refused a student visa before.
    
    
    
    Due to the Covid-Delta wave, the US embassy and consulates in India started student visa interviews very, as many aspirants received their I-20 documents from US universities and waiting for the interviews.
    
    This is the reason that there was a high issuance rate in 2020-21, accommodating most of them. To spruce up the numbers in 2021-22, the embassy will conduct student visa interviews by mid-May. The aim is to exceed student visas and surpass the previous year's tally of 62,000 issued visas.
    
    This decision will put eliminate any chance to get the interviews slots for the applicants who already appeared in multiple rounds of visa interviews adding to the list are those ones who were turned down in Spring this year and were planning to apply again in Summer.
    
    The opening up of visa interview and dropbox (categories that are exempt from interviews) slots across India for H and L visa categories. B-1 and B-2 visitor visa interview slots, for first-time applicants, are going to be opened on September 1, 2022. The US embassy expects to issue 80,000 visas to Indian students across categories and by the middle of 2023, the volume of visas issued is likely to bounce back 100% to pre-Covid times.`,
    dateNews: "",
    newsTitle:
      "Indian students who refused US visas the first time are unlikely to get a second interview slot this year:",
    longDescriptionNews: `<p>There was an important announcement made by consular affairs at the US embassy in Delhi regarding different categories of non-immigrant visas.</p>
    <p><br />The embassy reiterated that applicants for F-1 student visas from India will have a high success rate of getting visa approval in the first interview whereas more possibilities of being refused in the second/third interview slots.<br /><br />This policy change will allow all the fresh applicants, who are turning up for the first time for a visa interview to study in a US college, a chance with an eye on blocking the earlier applicant who was refused a student visa before.<br /><br />&nbsp;</p>
    <p>Due to the Covid-Delta wave, the US embassy and consulates in India started student visa interviews very, as many aspirants received their I-20 documents from US universities and waiting for the interviews.<br /><br />This is the reason that there was a high issuance rate in 2020-21, accommodating most of them. To spruce up the numbers in 2021-22, the embassy will conduct student visa interviews by mid-May. The aim is to exceed student visas and surpass the previous year's tally of 62,000 issued visas.<br /><br />This decision will put eliminate any chance to get the interviews slots for the applicants who already appeared in multiple rounds of visa interviews adding to the list are those ones who were turned down in Spring this year and were planning to apply again in Summer.<br /><br />The opening up of visa interview and dropbox (categories that are exempt from interviews) slots across India for H and L visa categories. B-1 and B-2 visitor visa interview slots, for first-time applicants, are going to be opened on September 1, 2022. The US embassy expects to issue 80,000 visas to Indian students across categories and by the middle of 2023, the volume of visas issued is likely to bounce back 100% to pre-Covid times.</p>`,
  },
];

const allThirdContent = [
  {
    newsCoverImg: article_img1,
    dateNews: "",
    shortDescription:
      "One of the critical decisions is to choose the right course from a university. To meet the eligibili...",
    newsTitle: "Statement of Purpose",
    longDescriptionNews:
      "One of the critical decisions is to choose the right course from a university. To meet the eligibili...",
  },

  {
    newsCoverImg: article_img2,
    dateNews: "",
    shortDescription:
      "Indian students prefer the UK as a study abroad destination because of the excellent scholarships th...",
    newsTitle: "Scholarships for Indian Students to Study in the UK",
    longDescriptionNews:
      "Indian students prefer the UK as a study abroad destination because of the excellent scholarships th...",
  },
  {
    newsCoverImg: article_img3,
    dateNews: "",
    shortDescription:
      "where a student actually wishes to go for his higher studies? Is there any specific language",
    newsTitle: "How to study abroad ?",
    longDescriptionNews:
      "where a student actually wishes to go for his higher studies? Is there any specific language",
  },

  {
    newsCoverImg: article_img4,
    newsTitle: "Decision: Making the choice to Study Abroad",
    dateNews: "",
    shortDescription:
      "A student, who wishes to study overseas, is often at a loss when it comes to",
    headingSecItem: "Here write article heding about blog",
    longDescriptionNews:
      "A student, who wishes to study overseas, is often at a loss when it comes to",
  },
  {
    newsCoverImg: article_img5,
    newsTitle: "Course in Demand: Masters of Financial Analytics",
    dateNews: "",
    shortDescription:
      "The Masters in Financial Analytics is a postgraduate program that imparts critical financial knowledge and skills. You will tend to gain broader understanding of finance with a basic insight financial management. This blog helps you with all information desired by you",
    headingSecItem: "Here write article heding about blog",
    longDescriptionNews:
      "Today, a degree in Financial Analytics with statistical and programming abilities open doors of opportunities to technology-intensive finance businesses. You are exposed to advanced tools adopted by world’s leading financial institutions like JP Morgan, Goldman Sachs, and Bank of America. The learning will give you sound knowledge for strategic decisions using programming languages like SAS, R, SQL and Python, in addition to mastering corporate finance",
  },
  {
    newsCoverImg: article_img6,
    newsTitle: "Top 10 Employable Degrees For You",
    dateNews: "",
    shortDescription:
      "A student, who wishes to study overseas, is often at a loss when it comes to",
    headingSecItem: "Here write article heding about blog",
    longDescriptionNews:
      "The job market is turning very competitive day by day and jobs are squeezed out",
  },
  {
    newsCoverImg: article_img7,
    newsTitle: "Short Term Courses after Class 12",
    dateNews: "",
    shortDescription:
      "A student, who wishes to study overseas, is often at a loss when it comes to",
    headingSecItem: "Here write article heding about blog",
    longDescriptionNews:
      "Stress & life go hand-in-hand. And, in a moment of worry, all you need is someone to listen, understand, and motivate",
  },
];

function NewsUpdates(props) {
  const navigate = useNavigate();
  const customeSlider = React.useRef();

  const gotoNext = () => {
    customeSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customeSlider.current.slickPrev();
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const renderSecItems = allSecItems.map((perSecItem) => {
    return (
      <div key={Math.random()}>
        <div className="heading_img_title_container">
          {perSecItem.contentType === "video" ? (
            <video
              controls
              preload="auto"
              playsInline
              autoPlay
              className="video_hero_section_news"
            >
              <source src={perSecItem.newsVideo} type="video/mp4" />
            </video>
          ) : (
            <img
              src={perSecItem.newsCoverImg}
              alt="news_img"
              className="news_img_sec_container"
            />
          )}

          <div className="paragraph_content_container">
            <p className="heading_slider_news">{perSecItem.newsTitle}</p>

            <p className="extra_news_text">
              {perSecItem.shortDescription.length > 1000
                ? perSecItem.shortDescription.substring(0, 1000) + "... "
                : perSecItem.shortDescription}
              <a
                href="NewsDetails"
                className="news_update_read_more"
                onClick={() => navigate("/NewsDetails", { state: perSecItem })}
              >
                ... Read more
              </a>
              <br />
            </p>
          </div>
        </div>
      </div>
    );
  });

  return (
    <section className="main_news_updates_container">
      <div className="under_news_update_container">
        <div className="news_update_header_container">
          <div className="dwec_news_update_logo_container">
            {/* <img src={dwec_logo} alt="dwec_img" className="dwec_logo_news" /> */}
          </div>
          <div
            className="heading_time_text_container wow pulse animated"
            data-wow-delay="500ms"
            data-wow-iteration="infinite"
            data-wow-duration="1s"
          >
            <p className="news_update_heading_text">NEWS & UPDATES</p>
            {/* <p className="time_text_news">Friday , 14 APR 2022</p> */}
          </div>
          <div className="blank_img" />
        </div>

        {/* scroll right to left */}

        <div className="scroll_line_container">
          <div className="headline_container">
            <div className="trending_news_container">
              <img className="trend_img" alt="trend_img" src={trending_img} />
            </div>
            <marquee
              className="headline_text"
              behavior="scroll"
              direction="left"
              scrollamount="5"
            >
              Both India and former colonial power Britain share strong trade
              ties, and more than a million people of Indian origin live in
              Britain after decades of migration is a testimony. Britain wants
              to tap into the wealth of India's middle classes and their
              appetite for premium products and services. Extending its green
              technology to India Britain is looking to consolidate and
              strengthen the service trade.
            </marquee>
          </div>
        </div>

        <div className="three_container">
          <div className="first_container">
            <div className="third_under_container">
              <p className="heading_related_text"> FLYING NOW !</p>
              {allFirstContent.map((perHeadingContent) => {
                return (
                  <div
                    className="img_heading_extra_content_news_container"
                    key={Math.random()}
                  >
                    <div className="img_news_container">
                      <img
                        src={perHeadingContent.newsCoverImg}
                        alt="news"
                        className="news_img_self"
                      />
                    </div>

                    <div className="heading_extra_content_container">
                      <p className="heading_news_text">
                        {perHeadingContent.newsTitle}
                      </p>

                      <p className="heading_news_extra_text">
                        {perHeadingContent.shortDescription.length > 220
                          ? perHeadingContent.shortDescription.substring(
                              0,
                              220
                            ) + `...  `
                          : perHeadingContent.shortDescription}
                        <a
                          href="NewsDetails"
                          className="news_update_read_more"
                          onClick={() =>
                            navigate("/NewsDetails", {
                              state: perHeadingContent,
                            })
                          }
                        >
                          Read more
                        </a>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="sec_container">
            <Slider {...settings} ref={customeSlider}>
              {renderSecItems}
            </Slider>

            <div className="btn_left_right_pkg_container">
              <button className="prev_btn_pkg" onClick={() => gotoPrev()}>
                <MdWest />
              </button>

              <button className="prev_btn_pkg" onClick={() => gotoNext()}>
                <MdEast />
              </button>
            </div>
          </div>
          <div className="third_container">
            <div className="third_under_container">
              <p className="heading_related_text">Related Article</p>

              {allThirdContent.map((perArticle) => {
                return (
                  <div
                    className="heading_img_sub_content_container"
                    key={Math.random()}
                  >
                    <p className="heading_news_text">{perArticle.newsTitle}</p>
                    <div className="img_sub_content_container">
                      <div className="img_article_container">
                        <img
                          src={perArticle.newsCoverImg}
                          alt="article_img"
                          className="article_img"
                        />
                      </div>
                      <p className="article_content_text">
                        {perArticle.longDescriptionNews.length > 50
                          ? perArticle.longDescriptionNews.substring(0, 50) +
                            `...  `
                          : perArticle.longDescriptionNews}

                        <a
                          href="#allBlogs"
                          className="news_update_read_more"
                          onClick={() => navigate("/Blog")}
                        >
                          Read more
                        </a>
                      </p>
                    </div>
                    <hr className="light_line_container" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsUpdates;
